export const numberInputTheme = {
  baseStyle: {
    field: {
      _readOnly: {
        cursor: 'not-allowed',
        background: 'gray.100'
      }
    }
  },
  defaultProps: {
    size: 'sm'
  }
}
